export default __webpack_public_path__ + "3b8d319fc9b7acbe10288b3153812629.svg";